{
    "name": "Striped Cavern Tomato",
    "binomial_name": "Solanum lycopersicum",
    "common_names": [
        "striped cavern",
        "Schimmeig Stoo"
    ],
    "description": "Striped Cavern is an heirloom tomato variety that produces medium-sized, thick-walled, hollow tomatoes similar to bell peppers. The tomatoes are often stuffed or added to fresh salsas. They have red skin with yellow and orange stripes and a sweet, mild taste. For larger yield and improved plant health, prune and stake plants.",
    "sun_requirements": "Full Sun",
    "sowing_method": "Direct seed indoors, transplant seedlings outside after hardening off",
    "spread": 0,
    "row_spacing": 0,
    "height": 120,
    "growing_degree_days": 0,
    "companions": [],
    "image": "",
    "icon": "/crops/icons/striped-cavern-tomato.avif"
}